import { adoptedStyle, createState, css, customElement, GemElement, html } from '@mantou/gem';
import { i18n } from 'src/i18n/basic';
import { theme } from 'src/theme';

import 'duoyun-ui/elements/tabs';
import 'src/elements/license';
import 'src/modules/keybinding';
import 'src/modules/sound-settings';
import 'src/modules/account-settings';
import 'src/modules/video-settings';
import 'src/modules/shortcut-settings';
import 'src/modules/ui-settings';

const style = css`
  :scope {
    display: flex;
    width: min(50vw, 50em);
    height: 50vh;
    -webkit-user-select: none;
    user-select: none;
  }
  .tabs {
    width: 100%;
  }
  .tabs::part(tabs) {
    width: 10em;
  }
  .tabs::part(tab) {
    padding: 0.5em;
  }
  .tabs::part(tab):hover {
    color: currentColor;
  }
  .tabs::part(current) {
    color: currentColor;
    background-color: ${theme.hoverBackgroundColor};
    border-radius: ${`${theme.normalRound} 0 0 ${theme.normalRound}`};
  }
  .tabs::part(marker) {
    display: none;
  }
`;

@customElement('m-settings')
@adoptedStyle(style)
export class MSettingsElement extends GemElement {
  #state = createState({ tab: 0 });

  #onChange = ({ detail }: CustomEvent<number>) => {
    this.#state({ tab: detail });
  };

  render = () => {
    return html`
      <dy-tabs
        class="tabs"
        orientation="vertical"
        @change=${this.#onChange}
        .value=${this.#state.tab}
        .items=${[
          {
            label: i18n.get('settings.keybinding.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-keybinding></m-keybinding>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.shortcut.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-shortcut-settings></m-shortcut-settings>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.sound.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-sound-settings></m-sound-settings>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.video.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-video-settings></m-video-settings>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.ui.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-ui-settings></m-ui-settings>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.account.title'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <m-account-settings></m-account-settings>
                </dy-tab-panel>
              `;
            },
          },
          {
            label: i18n.get('settings.license'),
            getContent() {
              return html`
                <dy-tab-panel>
                  <nesbox-license></nesbox-license>
                </dy-tab-panel>
              `;
            },
          },
        ]}
      ></dy-tabs>
    `;
  };
}
